import { Phone, ShieldCheck, Clock, IndianRupee } from "lucide-react";
import WhatsAppIcon from "@/components/WhatsAppIcon";
import Seo from "@/components/Seo";
import Breadcrumbs from "@/components/layout/Breadcrumbs";
import BookingForm from "@/components/BookingForm";
import { useSite, telLink, waLink } from "@/context/SiteContext";

export default function BookTaxi() {
  const s = useSite();
  return (
    <>
      <Seo title="Book a Taxi Online | Chouhan Taxi Service — Jodhpur, Jaipur, Udaipur, Jaisalmer"
        description="Book a taxi online with Chouhan Taxi Service for local, airport, one-way, round-trip and outstation travel across Rajasthan. Quick booking with instant WhatsApp confirmation."
        path="/book-taxi" />
      <Breadcrumbs items={[{ label: "Book a Taxi" }]} />
      <section className="section-pad pt-8">
        <div className="container-x grid grid-cols-1 lg:grid-cols-5 gap-10">
          <div className="lg:col-span-2">
            <h1 className="text-3xl sm:text-4xl font-heading font-extrabold text-navy-heading leading-tight">Book a Taxi</h1>
            <p className="mt-4 text-slate-600 leading-relaxed">Fill in your trip details and our team will call you shortly to confirm your booking and fare. Prefer to talk? Reach us instantly by phone or WhatsApp.</p>
            <div className="mt-6 space-y-3">
              {[[ShieldCheck, "Verified drivers & clean, AC vehicles"], [IndianRupee, "Transparent fares, no hidden charges"], [Clock, "Available round the clock, every day"]].map(([Icon, t]) => (
                <div key={t} className="flex items-center gap-3 text-slate-700"><div className="w-10 h-10 rounded-xl bg-brand-light flex items-center justify-center"><Icon className="w-5 h-5 text-brand" /></div><span className="text-sm font-medium">{t}</span></div>
              ))}
            </div>
            <div className="mt-8 flex flex-wrap gap-3">
              <a href={telLink(s)} className="inline-flex items-center gap-2 bg-navy text-white font-semibold px-6 py-3 rounded-full"><Phone className="w-4 h-4" /> {s.phone}</a>
              <a href={waLink(s)} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 bg-whatsapp text-white font-semibold px-6 py-3 rounded-full"><WhatsAppIcon className="w-4 h-4" /> WhatsApp</a>
            </div>
          </div>
          <div className="lg:col-span-3">
            <div className="bg-white rounded-2xl border border-slate-100 shadow-lg p-6 sm:p-8">
              <h2 className="font-heading font-bold text-navy-heading text-xl mb-5">Booking Details</h2>
              <BookingForm />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
